module.exports = __webpack_public_path__ + "img/staff frame.e3f36989.svg";